import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col } from 'reactstrap';

import * as actions from '../../actions/BlogActions';
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import BlogTeaser from "../../components/BlogTeaser/BlogTeaser";

class BlogContainer extends Component {

  componentDidMount() {
    const {loadBlogItems} = this.props;

    loadBlogItems();
  }

  render() {
    const { blogItems } = this.props;

    return (
      <Content>

        <Section>
          <Headline pageTitle>Quickdoctor-Blog</Headline>

          <Row>
            <Col sm={8}>
            {
              blogItems.length > 0 && blogItems.map(item => {
                return <BlogTeaser article={item} />
              })
            }
            </Col>
          </Row>

        </Section>

      </Content>
    )
  }
}

function mapStateToProps(state) {
  return {
    blogItems: state.blogItems,
  };
}

export default connect(mapStateToProps, actions)(BlogContainer);




// WEBPACK FOOTER //
// ./src/container/public/BlogContainer.js